import { render, staticRenderFns } from "./LaudoEmpresa.vue?vue&type=template&id=435bed28&scoped=true&lang=pug"
import script from "./LaudoEmpresa.vue?vue&type=script&lang=js"
export * from "./LaudoEmpresa.vue?vue&type=script&lang=js"
import style0 from "./LaudoEmpresa.vue?vue&type=style&index=0&id=435bed28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435bed28",
  null
  
)

export default component.exports